export enum MySeasonPassTypes {
    CURRENT = 'current',
    EXPIRED = 'expired',
}